import { closeShift, closeShiftForm, createShift, shiftForm } from '@/api/mutations/shift';
import { useState } from 'react';
import { setCashes, setPending, setShift } from '../../redux/data/dataSlice';
import { useAppDispatch } from '../../redux/hooks';

export const useShift = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const start = async (data: shiftForm) => {
    setIsLoading(true);
    return new Promise((resolve, reject) => {
      return createShift(data)
        .then(() => {
          dispatch(setShift(data));
          resolve(true);
        })
        .catch((err) => {
          if (!err.statusCode) {
            dispatch(
              setPending({
                type: 'START_SHIFT',
                ID: data.ID,
                data: JSON.stringify(data),
              })
            );
            dispatch(setShift(data));
          } else {
            return reject(err);
          }
        });
    });
  };

  const close = async (data: closeShiftForm) => {
    setIsLoading(true);
    return new Promise((resolve, reject) => {
      return closeShift(data)
        .then(() => {
          dispatch(setShift(null));
          dispatch(setCashes([]));
          resolve(true);
        })
        .catch((err) => {
          if (!err.statusCode) {
            dispatch(
              setPending({
                type: 'CLOSE_SHIFT',
                ID: data.shiftId,
                data: JSON.stringify(data),
              })
            );
            dispatch(setShift(null));
            dispatch(setCashes([]));
            resolve(true);
          } else {
            return reject(err);
          }
        });
    });
  };

  return { start, close, isLoading };
};
